const DEFAULT_MASTERY_COUNT = 3;
const DEFAULT_NOCQC = 1;
const DEFAULT_RADNOM_SUBCATEGORY_ORDER = 1;
const DEFAULT_REQUIRED = 1
const DEFAULT_AT_FIRST = 0;
const DEFAULT_AT_LAST = 0;
const DEFAULT_LOCKOUT = 20;
const DEFAULT_MAXIMUM_ATTEMPT = 2;
const DEFAULT_RANDOMIZE_CATEGORIES = 1;
const DEFAULT_END_SPLASH_SCREEN_TEXT = '<p dir="auto" style="">Congratulations! You are now a <strong>student Ninja</strong>.</p>';


const REQUIRED = 1;
const NOT_REQUIRED = 2;

const MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST = 30;

const DEFAULT_ZERO_POINT_RADIUS = 10;
const DEFAULT_ZERO_POINT_COLOR = "#dddddd";
const DEFAULT_VECTOR_SNAP_TO_GIRD = true;

const DEFAULT_LATEX_SYMBOL = 0; // Zero Vector
const DEFAULT_LATEX_SYMBOL_SIZE = 25;

export {
    DEFAULT_MASTERY_COUNT,
    DEFAULT_NOCQC,
    DEFAULT_RADNOM_SUBCATEGORY_ORDER,
    DEFAULT_REQUIRED,
    DEFAULT_AT_FIRST,
    DEFAULT_AT_LAST,
    DEFAULT_LOCKOUT,
    DEFAULT_MAXIMUM_ATTEMPT,
    DEFAULT_RANDOMIZE_CATEGORIES,

    REQUIRED,
    NOT_REQUIRED,
    MAX_QUESTION_COUNT_FOR_ONE_PAGE_TEST,
    DEFAULT_END_SPLASH_SCREEN_TEXT,
    DEFAULT_ZERO_POINT_RADIUS,
    DEFAULT_ZERO_POINT_COLOR,
    DEFAULT_VECTOR_SNAP_TO_GIRD,

    DEFAULT_LATEX_SYMBOL,
    DEFAULT_LATEX_SYMBOL_SIZE
};

export const SymbolType = Object.freeze({
    IN_PLANE: 0,
    SOLID_DOT: 1,
    OUT_ODOT: 2,
    IN_OTIMES: 3,
});


export const SFMessageType = Object.freeze({
    WARNING: 'warning',
    INFO: 'info',
    ERROR: 'error',
});